import CarouselCard from 'home/components/CarouselCard/CarouselCard'
import React from 'react'
import offerPageURL from 'lib/offer/offerPageURL'
import TourV2Location from './TourV2Location'
import useCheapestOfTourV2Offer from 'hooks/TourV2/useCheapestOfTourV2Offer'
import TourV2DurationText from './TourV2DurationText'
import useTourV2VariationDetails from 'hooks/TourV2/useTourV2VariationDetails'
import TourV2PriceDetails from './TourV2PriceDetails'
import TourV2UrgencyTags from 'components/Tours/TourV2UrgencyTags'
import BookmarkButton from 'tripPlanner/components/Bookmark/BookmarkButton'

interface Props {
  offer: Tours.V2Offer | Tours.V2OfferSummary;
  onClick: () => void;
}

function TourV2OfferCard({ offer, onClick }: Props) {
  const { cheapestPurchasableOption, cheapestVariation } = useCheapestOfTourV2Offer(offer)
  const variationDetails = useTourV2VariationDetails(cheapestVariation)
  if (!cheapestPurchasableOption || !cheapestVariation) {
    return null
  }

  const {
    startLocation,
    endLocation,
    hasTheSameStartAndEndLocation,
    countriesCount,
    durationInDaysCount,
    placesCount,
  } = variationDetails

  const updatedEndLocation = hasTheSameStartAndEndLocation ? startLocation : endLocation

  return (
    <CarouselCard
      bookmarkButton={<BookmarkButton offer={offer} />}
      description={<TourV2DurationText durationInDaysCount={durationInDaysCount} placesCount={placesCount} countriesCount={countriesCount}/>}
      image={cheapestVariation.images[0]}
      location={<TourV2Location startLocation={startLocation} endLocation={updatedEndLocation} variant="start_and_end"/>}
      title={offer.name}
      offerPriceDetails={<TourV2PriceDetails offer={offer}/>}
      offerUrl={offerPageURL(offer)}
      productType={offer.productType}
      urgencyLabels={<TourV2UrgencyTags tags={offer.urgencyTags} />}
      onClick={onClick}
    />
  )
}

export default TourV2OfferCard
